import { AdjacentType, BranchingQueryDefinition } from '@iotv/datamodel';
import { ExpressionFunctionType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { deviceEnabledTypes } from '@iotv/payload-definition';
import { ConsumerDao } from '../../../data/ConsumerDAO';
import config from '@iotv/config';
const dynamo = config.aws.dynamoDB;
/**
 * dev -> entity -> group -> customer
 */
export const getDeviceEntityGroupCustomer = () => {
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: 'Device' }],
        subQueries: [],
    });
    //   const groupToProperty = new BranchingQueryDefinition({
    //     id: `groupToProperty`,
    //     path: [
    //       {
    //         objectTypeId: 'Property',
    //         adjacencyType: AdjacentType.PARENT,
    //         edgeTypeId: undefined,
    //       },
    //     ],
    //     subQueries: [],
    //   })
    const groupToCustomer = new BranchingQueryDefinition({
        id: `groupToCustomer`,
        path: [
            {
                objectTypeId: 'Customer',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: undefined, //getChildEdgeTypeId('Customer', 'Property'), // 'group_has_area', //
            },
        ],
        subQueries: [], // thingToProperty,
    });
    let allowedTypes = Object.keys(deviceEnabledTypes);
    allowedTypes.forEach(type => {
        const devToEntityQuery = new BranchingQueryDefinition({
            id: `devTo${type}Query`,
            path: [
                {
                    objectTypeId: type,
                    adjacencyType: AdjacentType.PARENT,
                    edgeTypeId: undefined,
                },
            ],
            subQueries: [],
        });
        const entityToGroup = new BranchingQueryDefinition({
            id: `${type}ToGroup`,
            path: [
                {
                    objectTypeId: 'Group',
                    adjacencyType: AdjacentType.PARENT,
                    edgeTypeId: undefined,
                    nodeFilters: [
                        {
                            filters: [
                                {
                                    key: 'supportedType',
                                    predicate: ExpressionFunctionType.CONTAINS,
                                    value: type,
                                },
                            ],
                            setOperation: LogicalOperatorType.AND,
                        },
                    ],
                },
            ],
            subQueries: [],
        });
        apexQuery.addSubQuery(devToEntityQuery);
        devToEntityQuery.addSubQuery(entityToGroup);
        entityToGroup.addSubQuery(groupToCustomer);
        // entityToGroup.addSubQuery(groupToProperty)
    });
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
export const getAllUser = async () => {
    let usersPromise = await ConsumerDao.baseQuery({
        TableName: dynamo.tableName,
        IndexName: dynamo.typesiName,
        ExpressionAttributeNames: {
            '#pk': dynamo.pKey,
            '#type': dynamo.typesiPrimaryKey,
        },
        ExpressionAttributeValues: {
            ':type': 'User',
        },
        KeyConditionExpression: '#type = :type',
        FilterExpression: 'begins_with(#pk, :type)',
        ScanIndexForward: false,
    });
    return usersPromise.data;
};
